var BrowserFS = require('browserfs');module.exports=BrowserFS.BFSRequire('path');



/*****************
 ** WEBPACK FOOTER
 ** ./shims/path.js
 ** module id = 28
 ** module chunks = 0
 **/